import { gql } from '@apollo/client';

export const REGISTER_WALLET_PAYMENT_METHOD = gql`
  mutation Mutation($input: RegisterWalletPaymentMethodInput) {
    registerWalletPaymentMethod(input: $input) {
      walletTokenRegistrationRedirectUrl
    }
  }
`;
